import Vue from "vue";
import Router from "vue-router";
// eslint-disable-next-line import/no-cycle
// import Home from './views/Home.vue';
import Login from "./views/user/Login.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Login,
      meta: {
        auth: false,
      },
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./views/dashboard/Dashboard.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/user/Login.vue"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./views/user/Register.vue"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/thank-you",
      name: "thank-you",
      component: () => import("./views/user/Thank-you.vue"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/submit-course",
      name: "submit-course",
      component: () => import("./views/pages/Submit-course.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/telas-user",
      name: "telas-user",
      component: () => import("./views/dashboard/Telas-users.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/edit-profile/:userID",
      name: "edit-profile",
      component: () => import("./views/dashboard/Edit-profile.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/my-profile",
      name: "my-profile",
      component: () => import("./views/dashboard/Edit-profile.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/course/:courseId",
      name: "course-details",
      component: () => import("./views/dashboard/Course-details.vue"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/user-profile/:userId",
      name: "user-profile",
      component: () => import("./views/dashboard/User-profile.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/assessments",
      name: "assessments",
      component: () => import("./views/dashboard/Assessment-list.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/assessment/:assessmentId",
      name: "assessment-details",
      component: () => import("./views/dashboard/Assessment-details.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/report/comparative-summary/:reportId",
      name: "comparative-summary",
      component: () => import("./views/pages/Comparative-assessment.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/reports",
      name: "reports",
      component: () => import("./views/dashboard/Reports.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/report/:reportId",
      name: "report-detail",
      component: () => import("./views/pages/Report-detail.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/report/summary/:reportId",
      name: "report-summary",
      component: () => import("./views/pages/Report-summary.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/assessments/assigned",
      name: "assigned-assessments",
      component: () => import("./views/dashboard/Assessment-list.vue"),
    },
    {
      path: "/assessments/in-progress",
      name: "in-progress-assessments",
      component: () => import("./views/dashboard/Assessment-list.vue"),
    },
    {
      path: "/assessments/completed",
      name: "completed-assessments",
      component: () => import("./views/dashboard/Assessment-list.vue"),
    },
    {
      path: "/dashboard/email-notifications",
      name: "admin-email-notifications",
      component: () =>
        import("./views/dashboard/admin/Email-notifications-list.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/email-notifications/:templateId",
      name: "admin-email-notification-template",
      component: () => import("./views/dashboard/admin/Email-template.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/frameworks",
      name: "admin-assessment-framework",
      component: () => import("./views/dashboard/admin/Frameworks.vue"),
      meta: {
        auth: true,
      },
    },
    {
      path: "/dashboard/framework-details/:frameworkId",
      name: "framework-details",
      component: () => import("./views/dashboard/admin/Framework-details.vue"), // Adjust the path according to your project structure
      meta: {
        auth: true,
      },
      props: true, // This allows the component to receive the `frameworkId` as a prop
    },
  ],
});
router.beforeEach((to, from, next) => {
  const authRequired = to.meta.auth;
  const authed =
    localStorage.getItem("telasUserObj") !== null &&
    localStorage.getItem("telasUserObj").length > 0;
  if (authRequired) {
    if (!authed) {
      next("/login");
    } else {
      next();
    }
  } else if ((to.name === "login" || to.name === "home") && authed) {
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
